class SalaryPositions {
	async getPositions(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/positions/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return await response.json()
	}

	async postPosition(body) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/positions`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		})
		return await response.json()
	}

	async updatePosition(positionId, body) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/positions/${positionId}`, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(body),
		})
		return await response.json()
	}

	async getCompanyIdSmtm(companyName) {
		const response = await fetch(`https://smtm.co/v1/getCompanyIdFromMyDna?name=${companyName}`)
		return await response.json()
	}

	async dataToExcelPosition(companyId) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/position-list-to-excel/${companyId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		})

		return response.json()
	}

	async deletePosition(id, mydna_email_position) {
		const response = await fetch(`${process.env.REACT_APP_API}/salary/positions/${id}?mydna_email_position=${mydna_email_position}`, {
			method: 'DELETE',
			headers: {
				'Content-Type': 'application/json',
			},
		})
		return await response.json()
	}
}

export default new SalaryPositions()
